<template>
  <div class="payment-container">

    <!-- Payment info -->
    <div class="payment-info" v-if="!!prod_id&&!success">

      <!-- Title -->
      <div class="header-title">
        {{ $t('payment.enter_payment_details') }}
      </div>

      <!-- Methods -->
      <div class="summary">
        <div class="summary-title">
          {{ $t('payment.payment_methods') }}
        </div>
        <div class="summary-details">
          {{ $t('payment.'+price_unit.slice(-3)) }}
        </div>
      </div>

      <!-- Methods -->
      <div class="account-transfer">
        <div class="input-field">
          <v-text-field outlined flat
            v-model.lazy="name"
            @blur="$v.name.$touch()"
            :error-messages="nameErrors">
            <template v-slot:label>
              {{ $t('payment.depositor_name') }}
            </template>
          </v-text-field>
        </div>
      </div>

      <!-- Payment Summary -->
      <div class="summary">
        <div class="summary-title">
          {{ $t('payment.payment_summary') }}
        </div>
        <div class="summary-contents">
          <div class="summary-details">
            {{ $t('plans.'+product.name) }}
          </div>
          <div class="summary-price">
            {{ $t('plans.price_'+price_unit, 
              [parseInt(product['price_'+price_unit]).toLocaleString()])}}
          </div>
        </div>
      </div>

      <div class="commercial-terms" 
        v-html="$t('payment.commercial_terms')">
      </div>

      <!-- Actions -->
      <div class="actions">
        <v-btn depressed block color="primary" class="black--text"
          @click="openCashDialog()">
          결제하기
        </v-btn>
      </div>

      <div class="prev link-element">
        <div @click="prev()">
          '이용권 선택'으로 돌아가기
        </div>
      </div>

    </div>

    <!-- Success -->
    <div v-if="success">

      <!-- Success - cash -->
      <div>
        <div class="header-title">
          <div>이용권을 구입해주셔서</div>
          <div>감사합니다!</div>
        </div>
        <div class="header-meta">
          <div>{{ $t('payment.payment_request_text') }}</div>
          <div>BiblioTrees는 가로 1,000px 이상의 화면에 최적화되어 있습니다. 모바일 페이지를 선보일 예정이니 조금만 기다려주세요!😘</div>
        </div>
        <div class="actions">
          <router-link tag="div" class="btn"
            :to="{name: 'lab'}">
            <v-btn block depressed color="primary" @click="initiate()">
              {{ $t('payment.go_to_lab') }}
            </v-btn>
          </router-link>
        </div>
      </div>

    </div>

    <!-- cash_dialog -->
    <template>
      <v-dialog v-model="cash_dialog" v-if="!!prod_id"
        width="450px">
        <v-card>
          <v-card-title>
            {{ $t('payment.complete_the_deposit') }}
          </v-card-title>
          <v-card-text>
            <div>{{ $t('payment.deposit_text', [parseInt(product['price_'+price_unit]).toLocaleString()]) }}</div>
            <li>{{ $t('payment.account_number') }}: 100-033-372182 (신한은행, 예금주: 비블리오트리즈주식회사)</li>
          </v-card-text>
          <v-card-actions>
            <v-btn depressed block color="primary"
              @click="payWithCash()">
              {{ $t('actions.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Error dialog -->
    <template>
      <v-dialog v-model="error_dialog" width="400px">
        <v-card>
          <v-card-title>
            {{ $t('payment.payment_canceled') }}
          </v-card-title>
          <v-card-text>
            {{ $t('payment.try_again') }}
          </v-card-text>
          <v-card-actions>
            <v-btn depressed block color="primary"
              @click="retry">
              {{ $t('actions.retry') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    busy: {}
  },

  data() {
    return {
      prod_id: null,
      product: {},
      price_unit: 'KRW',
      success: false,
      name: "",
      cash_dialog: false,
      tk_id: null,
      error: false,
      error_dialog: false,
    }
  },

  computed: {
    ...mapGetters({
      user_type: 'user/user_type',
      end_date: 'user/end_date',
    }),

    nameErrors() {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.required && errors.push(this.$t('register.required'))
      return errors
    },
  },

  watch: {
    error: {
      handler(val) {
        if (val) { this.error_dialog = true }
      },
    },
  },

  async created() {
    let vm = this
    let error = false
    try {
      await this.$store.dispatch('welcome/getProducts')
    }
    catch(e) {
      error = true
      let status = !!e.response ? e.response.status : '000'
      this.$store.commit('error/setErrorCode', status)
      this.$store.commit('error/setDialog', true)
    }
    finally {
      if (!error) {
        let all_prods = this.$store.getters['welcome/products']
        this.prod_id = this.$store.getters['welcome/prod_id']
        this.product = all_prods.find(v => v.prod_id == vm.prod_id)
      }
    }
  },

  validations: {
    name: {
      required,
    },
  },

  methods: {
    updateBusy(state) {
      this.$emit('update:busy', state)
    },

    retry() {
      location.reload()
    },

    initiate() {
      this.$store.commit('welcome/resetProdId')
    },

    openCashDialog() {
      this.$v.$touch()
      if (!this.$v.$anyError) {
        this.cash_dialog = true
      }
    },
    
    async payWithCash() {
      let description = this.$t('payment.product_name') + ' : ' + this.$t('plans.' + this.product.name) + " | " +
        this.$t('payment.price') + ' : ' + this.$t('plans.price_unit', [parseInt(this.product['price_'+this.price_unit]).toLocaleString()]) + " | " +
        this.$t('payment.depositor_name') + ' : ' + this.name 
      try {
        await this.$store.dispatch('payment/payWithCash', {
          prod_id: this.prod_id
        })
        await this.$store.dispatch('ticket/createMyTicket', {
          title: this.$t('payment.payment_confirmation_request'),
          description: description,
          type: 102,
        })
      } catch(e) {
        this.error = true
      } finally {
        if (!this.error) {
          this.success = true
          this.tk_id = this.$store.getters['ticket/tk_id']
          this.$store.commit('welcome/resetEmail')
          this.$store.commit('welcome/resetProdId')
          let payment = this.$store.getters['payment/payment']
          this.$analytics.logEvent('pay_with_cash', {
            transactions_id: payment.pay_id,
            value: payment.amount,
            currency: payment.unit,
            product: payment.product,
            name: payment.product_name,
            kind: payment.kind,
            status: payment.status,
          })
        }
        this.cash_dialog = false
      }
    },

    prev() {
      this.$router.push({name:'signupform', params: {code: 'plans'}})
    },
  },

}
</script>

<style scoped>

  .header-title {
    padding: 10px 0 20px;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-meta {
    font-size: 14px;
    text-align: center;
  }

  .header-meta > div {
    margin-bottom: 12px;
  }

  .summary {
    display: flex;
    flex-direction: column;
    margin: 20px 0 20px;
  }

  .summary-title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .summary-contents {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
  }

  .summary-details {
    color: #676168;
  }

  .summary-price {
    font-size: 20px;
  }

  .commercial-terms {
    margin-bottom: 20px;
  }

  .actions > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .actions > .btn {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .prev {
    margin-top: 20px;
    text-align: end;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared_components/form/Payment.vue